import { db } from "../firebase/config";

const addProfile = (ID: string, data: any) => {
  db.collection("profiles").doc(ID).set(data, { merge: true });
};

export default addProfile;
